"use strict";
var RestrictedInput = require("./lib/restricted-input");
module.exports = RestrictedInput;
